import type { History } from 'history';
import { LocationListener } from 'history';
import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useHistory } from 'react-router-dom';

export function useOnNavigate(): LocationListener {
  const { location, push } = useHistory();

  return useCallback(
    (nextLocation) => {
      if (
        location.pathname !== nextLocation.pathname ||
        location.search !== nextLocation.search ||
        location.hash !== nextLocation.hash
      ) {
        push(nextLocation);
      }
    },
    [location, push],
  );
}

export function useInitialPath(): string {
  const { location } = useHistory();
  return useMemo(() => {
    return location.pathname + location.search + location.hash;
  }, [location.hash, location.pathname, location.search]);
}

type useCustomHistoryType = [
  history: History<unknown>,
  prevLocation: string,
  currentLocation: string,
];

let prev = '';
let curn = '';
export function useCustomHistory(): useCustomHistoryType {
  const history = useHistory();
  const prevLocation = useRef(prev);
  const currentLocation = useRef(curn);

  useEffect(() => {
    if (prevLocation.current !== currentLocation.current) {
      prevLocation.current = currentLocation.current;
      prev = prevLocation.current;
      currentLocation.current = history.location.pathname;
      curn = currentLocation.current;
      return;
    }
    currentLocation.current = history.location.pathname;
    curn = currentLocation.current;
  }, [history.location.search, history.location.pathname]);

  return [history, prev, currentLocation.current];
}
